import React from 'react'
import { useEditorStore } from '../store.js'
import { EditorInspector } from './EditorInspector.js'
import { SnapshotHistory } from './SnapshotHistory.js'
import { AIChatPanel } from './AIChatPanel.js'

type SidebarTab = 'inspector' | 'history' | 'chat'

export function RightSidebar() {
  const activeTab = useEditorStore(state => state.rightSidebarTab)
  const setActiveTab = useEditorStore(state => state.setRightSidebarTab)

  return (
    <aside className="right-sidebar">
      <div className="right-sidebar__tabs">
        <button
          type="button"
          className={`right-sidebar__tab ${activeTab === 'chat' ? 'right-sidebar__tab--active' : ''}`}
          onClick={() => setActiveTab('chat')}
        >
          AI Chat
        </button>
        <button
          type="button"
          className={`right-sidebar__tab ${activeTab === 'history' ? 'right-sidebar__tab--active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          History
        </button>
        {/* <button
          type="button"
          className={`right-sidebar__tab ${activeTab === 'inspector' ? 'right-sidebar__tab--active' : ''}`}
          onClick={() => setActiveTab('inspector')}
        >
          Inspector
        </button> */}
      </div>

      <div className="right-sidebar__content">
        {activeTab === 'chat' && <AIChatPanel />}
        {activeTab === 'history' && <SnapshotHistory />}
        {/* {activeTab === 'inspector' && <EditorInspector />} */}
      </div>
    </aside>
  )
}
